// extracted by mini-css-extract-plugin
export default {"solutions":"Solutions_solutions__jyzRR","title":"Solutions_title__zFpRA","subtitle":"Solutions_subtitle__9R+hZ"};